
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postSignUser = (params) => {
    return axios.post(`${backendHost}/api/admin/signuser`, params);
};

export {
    postSignUser
}